import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiGetPictureResponseBody } from '../PicturesApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUsePictureQueryValues = {
  appId: string;
  pictureId: string;
};

export const pictureQueryKeyFactory: IQueryKeyFactory<
  IUsePictureQueryValues
> = (values) =>
  values && (['picture', values.appId, values.pictureId] as const);

export const usePictureQuery = (
  values?: IUsePictureQueryValues,
  options?: UseQueryOptions<IApiGetPictureResponseBody, ApiError>,
): UseQueryResult<IApiGetPictureResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: pictureQueryKeyFactory(values),
    queryFn: values
      ? () => api.pictures.get(values.appId, values.pictureId)
      : undefined,
    enabled: !!values,
    retry: options?.retry ?? 1,
    retryDelay: options?.retryDelay ?? 500,
    ...options,
  });
};
